import CloseLessonAndRedirectFromHome from './container';

export default CloseLessonAndRedirectFromHome;
